export default __webpack_public_path__ + "static/media/format_icon_frame.c9b776a5.svg";